import L from 'leaflet';
import ICON from '../../assets/icons/map_marker_completed.svg';

const MapViewMarker = new L.Icon({
  iconUrl: ICON,
  iconRetinaUrl: ICON,
  iconAnchor: [13.5, 41],
  popupAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: new L.Point(27, 41),
});

export default MapViewMarker;
